<div class="modal-content">
  <div class="modal-header" >
          <button type="button" class="close" aria-label="Close" (click)="close()">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title" translate>GENERIC_PROJECT_CREATION</h4>
        </div>
        <div class="modal-body">
          <div class="portlet-body modal-body-min-h">
            <storever-header-subtitle [datas]="[ {icon: 'fa-map-marker-alt', title: 'GENERIC_CLIENT', name: name}  ]"></storever-header-subtitle>
            <form [formGroup]="myForm">
              <div class="textInput">
                <storever-element-group
                  [icon]="'fa-address-book'"
                  [title]="'none'"
                  [config]="formConfig.config"
                  [form]="myForm">
                </storever-element-group>
              </div>
            </form>
            <br>
            <div class="help-block error error-msg-padding" *ngIf="error !== 'false'">{{error}}</div>
          </div>
        </div>
        <br>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" [disabled]="!myForm.value.salesforceProjectId"
                  (click)="send(myForm.value)"> {{'GENERIC_LINK' | translate:locale.language}} </button>
          <button type="button" class="btn btn-default" (click)="close()">{{'CANCEL' | translate:locale.language}}</button>
        </div>
      </div>
